<div>
  <button class="contact__button" (click)="copyToClipboard($event, item.cellphone, 'Telefone')" matTooltip="{{item.cellphone}}" id="icon-phone">
    <img class="contact__icon contact__icon--phone"
      src="../../../../assets/svgs/i_phone.svg" alt="Icone de telefone" />
  </button>
  <button class="contact__button" (click)="copyToClipboard($event, item.email, 'Email')" matTooltip="{{item.email}}" id="icon-mail">
    <img class="contact__icon contact__icon--email"
      src="../../../../assets/svgs/i_email.svg" alt='Icone de email' />
  </button>
</div>